import { render } from "./BaloonPlayer.vue?vue&type=template&id=6cea76cb&scoped=true"
import script from "./BaloonPlayer.vue?vue&type=script&lang=js"
export * from "./BaloonPlayer.vue?vue&type=script&lang=js"

import "./BaloonPlayer.vue?vue&type=style&index=0&id=6cea76cb&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cea76cb"]])

export default __exports__